import { render, staticRenderFns } from "./WalletPurchases.html?vue&type=template&id=4744406a&scoped=true&external"
import script from "./WalletPurchases.js?vue&type=script&lang=js&external"
export * from "./WalletPurchases.js?vue&type=script&lang=js&external"
import style0 from "./WalletPurchases.vue?vue&type=style&index=0&id=4744406a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4744406a",
  null
  
)

export default component.exports